import React from "react";
import { Building, ThumbsUp, Award, CheckCircle } from "lucide-react"; // Add CheckCircle icon
import SpiracleLogo from '../../img/spiracle_logo.png';

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Us</h2>
                    <p className="hob-aboutus-text">
                        Spiracle Pest Management Services has been delivering professional and Integrated Pest Management services to residential & commercial premises across Mumbai and the suburbs of Mumbai for more than 10 years. We are committed to providing a professional, eco-friendly and cost-effective service solution for our valued customers with our trained and experienced staff.
                    </p>

                    {/* Added unordered list with icons */}
                    <ul className="hob-aboutus-list">
                        <li><CheckCircle size={20} /> 10+ Years Experience</li>
                        <li><CheckCircle size={20} /> Eco-friendly Treatments</li>
                        <li><CheckCircle size={20} /> Preventive Pest Management</li>
                        <li><CheckCircle size={20} /> Trusted Across Mumbai</li>
                    </ul>
                </div>

                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={SpiracleLogo}
                            alt="Spiracle Pest Worlds"
                            className="hob-aboutus-image"
                        />

                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Building size={18} />
                                <span>Since 2014</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Over 10 years of professional pest management.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <ThumbsUp size={18} />
                                <span>10K+ Happy Clients</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Trusted by thousands of satisfied clients.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>Eco-friendly Pest Control</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Safety first approach with best in class active ingredients.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;
